<div class="ranking-medals-wrapper">
<div *ngIf="Rnk > 3; else medals" class="position-text">{{(Rnk | positionCompetitionRank) | transloco | lowercase}}</div>
<ng-template #medals>
  <ng-container [ngSwitch]="Rnk">
    <div  class="position medal-gold" *ngSwitchCase="1"></div>
    <div  class="position medal-silver" *ngSwitchCase="2"></div>
    <div  class="position medal-bronze" *ngSwitchCase="3"></div>

  </ng-container>
</ng-template>
</div>
